import React, { useEffect, useState } from 'react';
import { fetchTransactionHistory } from '../../api';
import dayjs from 'dayjs';

const TransactionHistory: React.FC = () => {
  const [transactions, setTransactions] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getTransactionHistory = async () => {
      try {
        const response = await fetchTransactionHistory().then((res) => {
          setTransactions(res.items);
        });
      } catch (error) {
        console.error('Error fetching transaction history:', error);
      } finally {
        setLoading(false);
      }
    };

    getTransactionHistory();
  }, []);

  function formatVND(value: any) {
    const amount = Number(value);
    if (isNaN(amount)) return '0 đồng';
    return `${amount.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} đồng`;
  }

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-extrabold mb-6 text-center text-gray-800">Lịch sử nạp số dư</h1>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white rounded-lg shadow-md">
          <thead>
            <tr className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
              <th className="py-4 px-6 text-left font-semibold">Ngày</th>
              <th className="py-4 px-6 text-left font-semibold">Ngân hàng</th>
              <th className="py-4 px-6 text-left font-semibold">Số tiền</th>
              <th className="py-4 px-6 text-left font-semibold">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={4} className="py-6 px-4 text-center text-blue-500">
                  Đang tải dữ liệu...
                </td>
              </tr>
            ) : transactions && transactions.length > 0 ? (
              transactions.map((transaction: any, index: number) => (
                <tr key={index} className="border-b hover:bg-gray-100 transition-colors duration-150">
                  <td className="py-4 px-6 text-gray-700">{dayjs(transaction.time).format('DD/MM/YYYY HH:mm')}</td>
                  <td className="py-4 px-6 text-gray-700">{transaction.bankCode}</td>
                  <td className="py-4 px-6 text-yellow-600 font-semibold">{formatVND(transaction.amount)}</td>
                  <td>
                    <span
                      className={`py-1 px-6 font-semibold ${
                        transaction.vnpResponseCode === '00'
                          ? 'text-green-600 bg-green-100 rounded-full px-3 inline-block'
                          : 'text-red-600 bg-red-100 rounded-full px-3 inline-block'
                      }`}
                    >
                      {transaction.vnpResponseCode === '00' ? 'Thành công' : 'Thất bại'}
                    </span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="py-6 px-4 text-center text-gray-500">
                  Không tìm thấy giao dịch nào
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TransactionHistory;
